import API from './api'

const AuthService = {
  login: (data) => {
    return API.post('/login', data)
    .then(({ data }) => {
      if(data.success){
        setHeadersAndStorage(data)
      }
      return data
    })
    .catch(err => { throw err })
  },
  register: (data) => {
    return API.post('/register', data)
      .then(({ data }) => {
        // setHeadersAndStorage(data)
        return data
      })
      .catch(err => { throw err })
  },
  logout: (data, socket) => {
    return API.post('Endpoint here', data)
      .then(({ data }) => {
        removeHeadersAndStorage()
        return data
      })
      .catch(err => { throw err })
  },
}

const setHeadersAndStorage = ({ data }) => {
  API.defaults.headers['Authorization'] = `Bearer ${data.token}`
  //set localstorage here
}

const removeHeadersAndStorage = ({ data }) => {
  API.defaults.headers['Authorization'] = ``
  //remove localstorage here
}

export default AuthService